import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { AppStateType } from '../../reducers'
import { selectSettingsAccess } from '../../selectors/auth'
import { Header as Component } from './Header'
import { selectOverlayIsShown } from '../../selectors/overlay'

const mapStateToProps = (state: AppStateType) => ({
  displaySettingsIcon: selectSettingsAccess(state, {}),
  overlayIsShown: selectOverlayIsShown(state),
})

export const Header = withRouter(connect(mapStateToProps)(Component))
